import React from 'react';
import { Space, Input, Button } from 'antd';
import { Label } from '../../Layouts';

const UserFilter: React.FC<{ onSearch: () => void, values: Partial<SearchUserParams>, onChange: (v: Partial<SearchUserParams>) => void, }> =
    ({ values: params, onChange: setParams, onSearch }) => {
        return (
            <Space>
                <Label>
                    <Label>用户姓名</Label>
                    <Input.Search
                        onSearch={onSearch}
                        onChange={e => {
                            setParams({ ...params, queryName: e.target.value })
                        }} value={params.queryName} placeholder='请输入姓名' />
                </Label>
                <Label>
                    <Label>用户手机号</Label>
                    <Input.Search
                        onSearch={onSearch}
                        onChange={e => {
                            setParams({ ...params, queryPhone: e.target.value })
                        }} value={params.queryPhone} placeholder='请输入手机号' />
                </Label>
                <Label>
                    <Label>用户邮箱号</Label>
                    <Input.Search
                        onSearch={onSearch}
                        onChange={e => {
                            setParams({ ...params, queryEmail: e.target.value })
                        }} value={params.queryEmail} placeholder='请输入邮箱号' />
                </Label>

                <Button onClick={onSearch} style={{ marginTop: '1.4em' }} type='primary'>查询</Button>
            </Space>
        );
    }

export default UserFilter;